import * as angular from "angular";
import {IController} from 'angular';
import {LocationType} from "../../../commons/types/location.type";

export class RecurringServiceSelectItemComponent implements IController {

  recurringService: any;
  onSelect: Function;

  public locationTypes: typeof LocationType = LocationType;
  public taskColorByPurpose: any;

  constructor(private tasksConstants) {
    this.taskColorByPurpose = this.tasksConstants.typesToColor;
  }

  $onInit() {

  };


}

angular
  .module('bringoz.admin.deliveries')
  .component('recurringServiceSelectItem', {
    bindings: {
      recurringService: '<',
      isExcluded: '<?'
    },
    template: require('./recurring-service-select-item.html').default,
    controller: RecurringServiceSelectItemComponent
  });
